export const Background = () => (
  <div aria-hidden className="fixed inset-0 -z-10 pointer-events-none overflow-hidden bg-[#FBFAF7]">
    <div
      className="absolute left-1/2 top-1/2 w-[70vmin] h-[70vmin] -translate-x-1/2 -translate-y-1/2 opacity-[0.05]"
      style={{
        backgroundImage: "url('/logo.png')",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
    <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#E6B31E]/10 blur-3xl" />
    <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-[#E6B31E]/10 blur-3xl" />
  </div>
);
